export const environment = {
  production: true,
  url: 'https://certidaomilitancia-api.tjba.jus.br',
  packageFile: './../../../../package.json',
  VERSION: require('../../package.json').version,
  mocks: false,
  gridPageSize: 10,
  gridPageIndex: 0,
};
